import Equipment from "./../equipment";
import Ingredients from "./../ingredients";
import { recipeTypes } from "../recipeTypes";

const Recipe = {
  type: recipeTypes.main,

  title: "Chicken liver",

  subtitle: "with fried onion",

  background: require("../../media/chicken_liver_onion.jpg"),

  details: ["Crisp outside, soft inside.", "Serve with mash or toast."],

  equipment: [
    Equipment.Colander(),
    Equipment.Mixing_bowl("deep"),
    Equipment.Frying_pan("large"),
    Equipment.Plate("for onions"),
    Equipment.Platter("with kitchen paper"),
  ],

  optional_equipment: [Equipment.Baking_rack("for draining")],

  ingredients: [
    Ingredients.Chicken_livers("450g", "halved"),
    Ingredients.Flour("1 cup"),
    Ingredients.Onion(1, "large, half rings"),
    Ingredients.Vegetable_oil(120, "or light olive oil"),
  ],

  optional_ingredients: [Ingredients.Salt(), Ingredients.Pepper(), Ingredients.Parsley("for serving")],

  prep: ["Rinse and drain livers", "Slice onion", "Put FLOUR in a deep bowl"],

  prep_time: 10,

  method: [
    "Fry ONION in OIL until golden",
    "Remove ONION and keep the oil",
    "Dredge LIVERS in FLOUR",
    "Fry LIVERS in batches in the onion oil",
    "Cook 2-3 min per side",
    "Drain on paper or rack",
    "Season right away",
    "Serve with ONION on top",
  ],

  cook_time: 20,
};

export default Recipe;
